import React, { useState } from "react";
import { Row, Col, Container, Modal, Button } from "react-bootstrap";
import PolicyItem from "./sections/PolicyItem";
import PolicyItemMobile from "./sections/PolicyItemMobile";
import SearchBar from "../../components/searchbar/SearchBar";
import "./policy.css";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  GetEthicsPolicies,
  selectEPolicies,
} from "../../features/ethicspolicies/ethicspolicySlice";
import { Form, InputGroup } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Search from "../../assets/images/search-line.svg";
import Feedback from "../../components/feedbackNote/Feedback";
import ModalDelete from "../../assets/images/delete-bin-line.svg";
import {
  GetLogsTracker,
  selectLogsTracker,
} from "../../features/login/logsTracker";
import {
  GetUserPermisionData,
  selectUserPermisionData,
} from "../../features/rolebase/userPermissionSlice";
import { policyAPi } from "../../features/network/ApiCall";
import icTitle from "../../assets/images/ic-edit-modal.svg";
import ENGModalHeader from "../../components/modal/ENGModalHeader";
import FileUpload from "../../components/textField/FileUpload";
import EmptyRow from "../../components/emptyRow/EmptyRow";
import ENGModalBody from "../../components/modal/ENGModalBody";
import { useForm } from "react-hook-form";
import { GetUpdatePolicy } from "../../features/ethicspolicies/updatePolicySlice";
import { GetInsertPolicy } from "../../features/ethicspolicies/insertPolicySlice";
import { GetDeletePolicy } from "../../features/ethicspolicies/deletePolicySlice";
import {
  GetEthicsPoliciesMrise,
  selectEPoliciesMrise,
  selectPOSHPolicies,
} from "../../features/ethicspolicies/getEpolicyMrise";
import { isPermited } from "../../features/localStorage";
import {
  GetAllCompany,
  selectAllCompany,
} from "../../features/company/companyListSlice";
import LoadSpinner from "../../components/Spinner/Spinner";

const required = "This field is required";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const Policies = ({ type = "ETHICS" }) => {
  const LogsTracker = useAppSelector(selectLogsTracker);
  const allCompany: any = useAppSelector(selectAllCompany);
  const epolicyMrise = useAppSelector(selectEPoliciesMrise);
  const poshPolicies = useAppSelector(selectPOSHPolicies);
  const epolicy = useAppSelector(selectEPolicies);

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const policySourceType = JSON.parse(userDetailsList);
  const selectedCompanyId = policySourceType?.companyId;

  const dispatch = useAppDispatch();
  const [policyListArr, setPolicyListArr] = useState<any>();
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const [modalTitle, setModalTitle] = useState("");
  const [policyName, setPolicyName] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");
  const [eligibility, setEligibility] = useState("");
  const [keys, setKeys] = useState("");
  const [guidelines, setGuidelines] = useState("");
  const [objective, setObjective] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [recordId, setRecordId] = useState<Number>();
  const [companyId, setCompanyId] = useState();

  useEffect(() => {
    setCompanyId(selectedCompanyId);
  }, [selectedCompanyId]);

  //console.log(policySourceType?.companyId)
  var moduleName = "Ethics_Policies";
  var searchParams = {
    type: "",
    id: 0,
  };

  useEffect(() => {
    async function fetchCompanyData() {
      let sample = await dispatch(GetAllCompany(searchParams));
    }
    fetchCompanyData();
  }, []);

  useEffect(() => {
    async function fetchLogsTracker() {
      let sample = await dispatch(GetLogsTracker(moduleName));
    }
    fetchLogsTracker();

    // getPolicyList();
  }, []);

  const [policyList, setPolicyList] = useState<any>();

  // const getPolicyList = () => {
  //   if (policySourceType?.mahindraCompanyList?.policySource === true) {
  //     // call ethics and governace policy from eng portal
  //     console.log(companyId);
  //     const fetchPolicy = async () => {
  //       await dispatch(GetEthicsPolicies(selectedCompanyId));
  //     };
  //     fetchPolicy();
  //   } else {
  //     // call ethics and governace policy from mrise portal
  //     const fetchPolicyMrise = async () => {
  //       await dispatch(GetEthicsPoliciesMrise(type));
  //     };
  //     fetchPolicyMrise();
  //   }
  // };

  useEffect(() => {
    if (policySourceType?.mahindraCompanyList?.policySource === true) {
      setPolicyListArr(epolicy);
    } else {
      if (type == "POSH") {
        setPolicyListArr(poshPolicies);
      } else {
        setPolicyListArr(epolicyMrise);
      }
    }
  }, [epolicy, epolicyMrise, poshPolicies]);

  const [searchData, setsearchData] = useState("");
  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
    };

    await dispatch(GetEthicsPolicies(companyId));
  };
  const UserPermision = useAppSelector(selectUserPermisionData);
  useEffect(() => {
    async function fetchUserPermission() {
      let sample = await dispatch(GetUserPermisionData());
    }
    fetchUserPermission();
  }, []);
  const handleShow = () => {
    setModalShow(true);
    setModalTitle("Add Policy");
    setIsEdit(false);
  };
  const handleEdit = (item: any) => {
    setIsEdit(true);
    setModalShow(true);
    setModalTitle("Edit Policy");
    setRecordId(item.policyId);
    setPolicyName(item.policyName);
    setEffectiveDate(item.effectiveDate);
    setEligibility(item.eligibility);
    setKeys(item.policyKey);
    setGuidelines(item.generalGuidLines);
    setDescription(item.description);
    setFile(item.policy_pdf_link);
    setObjective(item.objectives);
  };
  const clearForm = () => {
    setPolicyName("");
    setEffectiveDate("");
    setEligibility("");
    setKeys("");
    setGuidelines("");
    setDescription("");
    setFile("");
    setObjective("");
  };
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //event.preventDefault();
    //  alert()
    if (isEdit === false) {
      var data = {
        policyName: policyName,
        effectiveDate: effectiveDate,
        eligibility: eligibility,
        generalGuidLines: guidelines,
        policyKey: keys,
        description: description,
        objectives: objective,
        policy_pdf_link: file,
      };
      // console.log(data)

      await dispatch(GetInsertPolicy(data));
      await dispatch(GetEthicsPolicies(companyId));
      await setModalShow(false);
      await clearForm();
    } else {
      var editdata = {
        policyId: recordId,
        policyName: policyName,
        effectiveDate: effectiveDate,
        eligibility: eligibility,
        generalGuidLines: guidelines,
        policyKey: keys,
        description: description,
        objectives: objective,
        policy_pdf_link: file,
      };
      //console.log(editdata)
      await dispatch(GetUpdatePolicy(editdata));
      await dispatch(GetEthicsPolicies(companyId));
      await setModalShow(false);
    }
  };
  const handleDelete = (item: any) => {
    setRecordId(item.policyId);
    setModalShow1(true);
  };
  const [modalShow1, setModalShow1] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState<Number>();

  const handleClose1 = () => setModalShow1(false);
  const handleShow1 = (item: any) => {
    setModalShow1(true);
    setDeleteRecord(item.id);
  };

  const onDeleteRecord = async () => {
    await dispatch(GetDeletePolicy(recordId));
    await dispatch(GetEthicsPolicies({ type, companyId }));
    setModalShow1(false);
  };
  // const handleCompanyChange = async (event: any) => {
  //   await setCompanyId(event.target.value);
  //   await dispatch(GetEthicsPolicies(event.target.value));
  // };
  return (
    <>
      {/* <Row>
        <Col lg={6} md={6} sm={6}>
          <h3 style={{ color: "#fff" }}>Ethics Policies</h3>
        </Col>
        <Col sm={2}></Col>
        <Col sm={4}>
          <InputGroup
            className="border bg-white"
            style={{ border: "solid 1px #e4e4e4" }}
          >
            <Image
              style={styles.image1}
              className="d-inline border-0 my-auto mx-2"
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className="border-0 shadow-none ps-0"
              style={styles.text1}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
      </Row> */}

      <div className="desk mt-2 p-2">
        <Row className="mt-2">
          <Col sm={6} className="mb-3 mob-lr-padding0">
            <h4>
              Showing{" "}
              <span className="policies">
                {policyListArr?.length}
                &nbsp; Policies
              </span>
            </h4>
          </Col>
          {policySourceType?.mahindraCompanyList?.policySource === true &&
            isPermited(11, 2) && (
              <Col lg={2} md={2} sm={2}>
                <>
                  <a onClick={() => handleShow()}>
                    <button style={styles.button}> Add Policy </button>
                  </a>
                </>
              </Col>
            )}
          {/* <Col sm={4} md={4}>
            <InputGroup
              className="border bg-white"
              style={{ border: "solid 1px #e4e4e4" }}
            >
              <Image
                style={styles.image1}
                className="d-inline border-0 my-auto mx-2"
                src={Search}
                fluid
              />
              <Form.Control
                onChange={(e) => searchItems(e.target.value)}
                name={searchData}
                className="border-0 shadow-none ps-0"
                style={styles.text1}
                type="text"
                placeholder="Search"
              />
            </InputGroup>
          </Col> */}
          {/* <Col lg={3} md={3} sm={3}>
            {policySourceType?.mahindraCompanyList?.policySource === true ? (
              <select
                onChange={(e) => handleCompanyChange(e)}
                name="sector"
                className="textstyle"
                value={companyId}
              >
                <option value="">Select Company</option>
                {allCompany?.map((item: any) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.company}
                    </option>
                  );
                })}
              </select>
            ) : null}
          </Col> */}
        </Row>
        <div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
          <Row className="px-4 py-3 bottom_line">
            <Col lg={2} md={2} sm={2} style={styles.heading}>
              Policy Name
            </Col>
            <Col lg={4} md={4} sm={4} style={styles.heading}>
              Context
            </Col>
            <Col lg={2} md={2} sm={2} style={styles.heading}>
              Effective Date
            </Col>
            {UserPermision?.roleId === 1 || UserPermision === 5 ? (
              <Col lg={2} md={2} sm={2} style={styles.heading}>
                Last Updated On
              </Col>
            ) : null}
            <Col lg={1} md={1} sm={1} style={styles.heading}>
              Download
            </Col>
            {policySourceType?.mahindraCompanyList?.policySource === true ? (
              <Col lg={1} md={1} sm={1} style={styles.heading}>
                Action
              </Col>
            ) : null}
          </Row>
        </div>
        {!policyListArr || policyListArr?.length === 0 ? (
          <LoadSpinner />
        ) : policyListArr?.length > 0 ? (
          [...policyListArr]
            ?.sort((a: any, b: any) => a.limits - b.limits)
            ?.map((item: any, i: any) => {
              return (
                <PolicyItem
                  key={i + 1}
                  item={item}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  GetUserPermision={UserPermision}
                />
              );
            })
        ) : (
          <span style={styles.text1}>No Records Available</span>
        )}
      </div>
      <div className="mob">
        <Row className="mt-2">
          <Col sm={6} className="mb-3 mob-lr-padding0">
            <h6>
              Showing{" "}
              <span className="policies">
                {policyListArr?.length}
                &nbsp; Policies{" "}
              </span>
            </h6>
          </Col>
          <Col lg={6} md={6} sm={6}></Col>
        </Row>
        {!policyListArr || policyListArr?.length === 0 ? (
          <LoadSpinner />
        ) : policyListArr?.length > 0 ? (
          [...policyListArr]
            ?.sort((a: any, b: any) => a.limits - b.limits)
            ?.map((item: any, i: any) => {
              return <PolicyItemMobile key={i + 1} item={item} />;
            })
        ) : (
          <span style={styles.text1}>No Records Available</span>
        )}
      </div>
      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="xl"
        keyboard={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <ENGModalHeader icon={icTitle} title={modalTitle} />
          <Modal.Body>
            <Row>
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="text"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setPolicyName(ev.target.value)
                    }
                    name="policyName"
                    ref={register({ required: true })}
                    defaultValue={policyName}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Policy Name <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.policyName &&
                  errors.policyName.type === "required" &&
                  errorMessage(required)}
              </Col>
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="date"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setEffectiveDate(ev.target.value)
                    }
                    name="effectiveDate"
                    ref={register({ required: true })}
                    defaultValue={effectiveDate}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Effective Date <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.effectiveDate &&
                  errors.effectiveDate.type === "required" &&
                  errorMessage(required)}
              </Col>

              <Col sm={12} xl={4} md={4}>
                <FileUpload
                  setFile={setFile}
                  title="File"
                  fileValue=""
                  fileType="PDF"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="text"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setEligibility(ev.target.value)
                    }
                    name="eligibility"
                    ref={register({ required: true })}
                    defaultValue={eligibility}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Eligibility <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.eligibility &&
                  errors.eligibility.type === "required" &&
                  errorMessage(required)}
              </Col>
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="text"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setKeys(ev.target.value)
                    }
                    name="key"
                    ref={register({ required: true })}
                    defaultValue={keys}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Key <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.key &&
                  errors.key.type === "required" &&
                  errorMessage(required)}
              </Col>
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="text"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setObjective(ev.target.value)
                    }
                    name="objective"
                    ref={register({ required: true })}
                    defaultValue={objective}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Objective <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.objective &&
                  errors.objective.type === "required" &&
                  errorMessage(required)}
              </Col>
            </Row>
            <Row className="mt-4">
              <Col sm={12} xl={4} md={4}>
                <div className="floating-label-group">
                  <input
                    type="text"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setGuidelines(ev.target.value)
                    }
                    name="guidelines"
                    ref={register({ required: true })}
                    defaultValue={guidelines}
                    className="textstyle"
                  />
                  <label className="floating-label">
                    Guidelines <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.guidelines &&
                  errors.guidelines.type === "required" &&
                  errorMessage(required)}
              </Col>
            </Row>
            <Row className="mt-4">
              <Col sm={12} xl={12} md={12}>
                <div className="floating-label-group">
                  <textarea
                    className="textstyle form-control"
                    onChange={(
                      ev: React.ChangeEvent<HTMLTextAreaElement>
                    ): void => setDescription(ev.target.value)}
                    name="description"
                    ref={register({ required: true })}
                    defaultValue={description}
                  ></textarea>
                  <label className="floating-label">
                    Description <span style={styles.star}> * </span>
                  </label>
                  {errors.description &&
                    errors.description.type === "required" &&
                    errorMessage(required)}
                </div>
              </Col>
            </Row>
            <Button
              style={styles.button}
              variant="primary"
              type="submit"
              className="mt-3 mb-3"
            >
              Submit
            </Button>
          </Modal.Body>
        </form>
      </Modal>
      {/* delete modal */}
      <Modal
        show={modalShow1}
        onHide={handleClose1}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <ENGModalHeader icon={ModalDelete} title=" Delete Record " />
        <ENGModalBody
          contents={
            <>
              <Row style={styles.divWhite}>
                <Col lg={12}>
                  <p style={styles.delcontent}>
                    Are you sure you want delete this record?
                  </p>
                </Col>
              </Row>
            </>
          }
        />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <Row style={styles.divGrey}>
          <Col sm={9}></Col>
          <Col sm={3}>
            <button type="button" onClick={handleClose1} style={styles.button1}>
              {" "}
              CANCEL{" "}
            </button>
            <button
              type="button"
              onClick={onDeleteRecord}
              style={styles.button}
            >
              {" "}
              DELETE{" "}
            </button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

const styles: any = {
  heading: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "600",
  },
  image1: {
    width: "24px",
    height: "24px",
  },
  star: {
    color: "#e31837",
  },
  text1: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "left",
    paddingLeft: "0.5rem",
  },
  button: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    color: "#fff",
    float: "right",
  },
  button1: {
    padding: "13px 15px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border: "1px solid #e31837",
    letterSpacing: "normal",
    color: "#e31837",
  },
  divWhite: {
    backgroundColor: "#ffffff",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  divGrey: {
    backgroundColor: "rgb(250, 249, 249)",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "20px",
    borderTop: "1px solid #eee;",
  },
  delcontent: {
    fontSize: "16px",
    color: "#242424",
  },
};

export default Policies;
